
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[dynamic]",
      function () {
        return require("private-next-pages/blog/category/[dynamic]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/category/[dynamic]"])
      });
    }
  